/* eslint-disable react/jsx-curly-newline */
/* eslint-disable object-shorthand */
/*  eslint-disable */

import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';

import AccordionEquipmentGrid from 'components/atoms/AccordionEquipmentGrid';
import TableTree, {
  AddMoreCell,
  CheckboxCell,
  LoadMoreCell,
} from 'components/molecules/TableTree';
import {
  IColumns,
  IExpandableRow,
  IExtraRowInfo,
  IRowLoading,
  IRowSelected,
  ITableRef,
} from 'components/molecules/TableTree/types';
import { recursivelyUpdateTable } from 'components/molecules/TableTree/utils';
import { GROUPS } from 'constants/permissions';
import { useSelectFilter } from 'hooks/planning/useFilter';
import { IEquipmentGrid, IEquipmentGridData } from 'interfaces/Equipment';
import qs from 'qs';
import React, { useEffect } from 'react';
import { useInfiniteQuery, useQuery } from 'react-query';
import { getEquipmentGridData, postGridTotal } from 'services/equipment';
import { IRegisterEquipmentGrid } from 'components/molecules/RegisterEquipmentGrid/types';
import useStyles from './style';

const TAKE = 10;

const GridTreeOthers = ({
  equipmentDescription,
  equipmentCode,
  installation,
  installationId, 
  setEquipmentList,
  toggleState,
}: IRegisterEquipmentGrid) => {
  const classes = useStyles();

  const equipmentFilter = useSelectFilter('description');
  const [gridInfo, setGridInfo] = React.useState<any>([]);

  const [openGrid, setOpenGrid] = React.useState(true);
  const [tableData, setTableData] = React.useState<IEquipmentGrid[]>([]);
  const tableRef = React.useRef<ITableRef>(null);
  const [isRowLoading, setIsRowLoading] = React.useState<IRowLoading>({});
  const [isRowSelected, setIsRowSelected] = React.useState<IRowSelected>({});
  const [extraRowInfo, setExtraRowInfo] = React.useState<IExtraRowInfo>({});
  const [addEquipmentSelected, setAddEquipmentSelected] =
    React.useState<IEquipmentGrid | null>(null);
  const [openModalRegister, setOpenModalRegister] =
    React.useState<boolean>(false);

  const canQueryGridData = React.useMemo(() => openGrid, [openGrid]);

  const params = React.useMemo(
    () => ({
      equipmentCode,
      equipmentIds: [],
      order: [],
    }),
    [equipmentCode, equipmentFilter],
  );
  const getNextPageParam = React.useCallback(
    (
      lastPage: IEquipmentGridData<IEquipmentGrid[]>,
      allPages: IEquipmentGridData<IEquipmentGrid[]>[],
    ) => {
      const allResults = allPages.map(page => page.result).flat().length;

      const hasNextPage = allResults < lastPage.count;
      if (hasNextPage) return allResults;

      return undefined;
    },
    [],
  );

  const queryEquipmentsGrid = useInfiniteQuery({
    queryKey: [`queryEquipmentsGridForCode${equipmentCode}`, params],
    queryFn: async ({ pageParam = 0 }) => {
      const qsparams = qs.stringify({
        cursor: pageParam,
        take: TAKE,
      });

      const { data } = await getEquipmentGridData({
        qsparams,
        params,
        isRootLevel: true,
      });

      return data;
    },
    getNextPageParam,
    onSuccess: ({ pages, pageParams }) => {
      const result = pages.map(item => item.result).flat();
      let pageParam = TAKE;

      if (pageParams.length) {
        if (typeof pageParams[1] === 'number') [, pageParam] = pageParams;
      }

      if (tableData && pageParam > TAKE) {
        const existingRowsIds = tableData.map(row => row.id);
        const newRows = result.filter(row => !existingRowsIds.includes(row.id));

        setTableData([...tableData, ...newRows]);
      } else {
        setExtraRowInfo({});
        setIsRowLoading({});
        setIsRowSelected({});
        if (tableRef.current?.resetExpandedRow)
          tableRef.current?.resetExpandedRow();

        setTableData(result);
      }
    },
    enabled: canQueryGridData, // so vai executar consultas se a grid estiver aberta
    cacheTime: 0,
  });

  const isLoading = React.useMemo(
    () => {
      // return (
      //   // queryGridTotalItems.isFetching ||
      //   // queryGridTotalItems.isLoading ||
      //   queryEquipmentsGrid.isLoading || queryEquipmentsGrid.isFetching
      // );
    },
    [
      // queryEquipmentsGrid.isFetching,
      // queryEquipmentsGrid.isLoading,
      // queryGridTotalItems.isFetching,
      // queryGridTotalItems.isLoading,
    ],
  );

  const toggleAddEquipment = React.useCallback(async row => {
    await setAddEquipmentSelected(row);
    setOpenModalRegister(true);
  }, []);

  const addSelectedRow = React.useCallback(
    (row: IEquipmentGrid) => {
      setGridInfo({
        ...gridInfo,
        selectedRows: [...(gridInfo?.selectedRows || []), row],
      });
    },
    [gridInfo, setGridInfo],
  );

  const removeSelectedRow = React.useCallback(
    (row: IEquipmentGrid) => {
      const selectedRows = gridInfo?.selectedRows || [];

      const rowIndex = selectedRows.findIndex(sRow => sRow.id === row.id);

      if (rowIndex >= 0) {
        setGridInfo({
          ...gridInfo,
          selectedRows: [
            ...selectedRows.slice(0, rowIndex),
            ...selectedRows.slice(rowIndex + 1),
          ],
        });
      }
    },
    [gridInfo, setGridInfo],
  );

  useEffect(() => {
    setIsRowSelected({});
  }, [toggleState]);

  const toggleSelectRow = React.useCallback(
    ({ original }: { original: IEquipmentGrid }) => {
      const { id } = original;

      if (!isRowSelected[id]) {
        addSelectedRow(original);
      } else {
        removeSelectedRow(original);
      }

      setIsRowSelected(currentValues => ({
        ...currentValues,
        [id]: !currentValues[id],
      }));
    },
    [addSelectedRow, isRowSelected, removeSelectedRow],
  );

  const handleLoadChild = React.useCallback(
    async ({
      id,
      original,
      isExpanded,
    }: {
      id: string;
      original: IExpandableRow<IEquipmentGrid>;
      isExpanded: boolean | undefined;
    }) => {
      let result = [] as IEquipmentGrid[];

      try {
        setIsRowLoading({ [id]: true });

        let cursor = 0;

        if (original.code.length<11&&isExpanded && extraRowInfo[original.code]?.cursor) {
          cursor = extraRowInfo[original.code]?.cursor;
        }
        if(original.code.length<11){

          const { data } = await getEquipmentGridData({
            qsparams: qs.stringify({
              cursor,
              take: TAKE,
            }),
            params: {
              ...params,
              equipmentCode: original.code,
            },
            isRootLevel: false,
          });
  
          result = data.result;
  
          setExtraRowInfo(currentValues => ({
            ...currentValues,
            [original.code]: {
              cursor: cursor + TAKE,
              count: data.count,
            },
          }));
        }
      } finally {
        setIsRowLoading({ [id]: false });
      }

      if (tableData) {
        const updatedTableData = recursivelyUpdateTable({
          tableData,
          childData: result,
          id,
        });

        setTableData(updatedTableData);
      }
    },
    [extraRowInfo, params, tableData],
  );

  const renderEmptyCell = React.useCallback((value: string) => {
    if (value) return undefined;
    return '-';
  }, []);

  const columns = React.useMemo<IColumns>(() => {
    return [
      {
        id: 'checkbox',
        Header: () => null,
        Cell: props => (
          <CheckboxCell {...props} handleClickRow={toggleSelectRow} />
        ),
        width: 20,
        disableResizing: true,
      },
      {
        accessor: 'code',
        Header: 'Código',
        width: 80,
        disableResizing: true,
        align: 'center',
      },
      {
        accessor: 'description',
        Header: 'Descrição',
        width: 100,
        disableResizing: true,
        align: 'center',
        Cell: (params: any) => (
          <Tooltip title={params?.row?.original.description}>
            <span>{(params?.row?.original.description).substring(0, 9)}</span>
          </Tooltip>
        ),
      },

      // {
      //   Header: () => <div />,
      //   id: 'add-child',
      //   width: 50,
      //   disableResizing: true,
      //   Cell: props => (
      //     <AddMoreCell {...props} handleClickRow={toggleAddEquipment} />
      //   ),
      // },
      {
        Header: () => <div />,
        id: 'load-more',
        width: 130,
        disableResizing: true,
        Cell: props => (
          <LoadMoreCell {...props} handleClickRow={handleLoadChild} />
        ),
      },
    ];
  }, [handleLoadChild, renderEmptyCell, toggleAddEquipment, toggleSelectRow]);

  const NoDataComponent = React.useCallback(() => {
    return (
      <div className={classes.noDataComponent}>
        <span>Sem Dados Disponíveis</span>
      </div>
    );
  }, [classes.noDataComponent]);

  const LoadingDataComponent = React.useCallback(() => {
    return (
      <div className={classes.loadingDataComponent}>
        <CircularProgress color="inherit" />
      </div>
    );
  }, [classes.loadingDataComponent]);

  
  useEffect(() => {
    if (setEquipmentList){
      setEquipmentList(gridInfo?.selectedRows);
    }
      
  }, [gridInfo]);

  return (
    <>
      {/* <EquipmentModalRegister
        open={openModalRegister}
        onClose={() => setOpenModalRegister(false)}
        selectedRow={addEquipmentSelected}
        // reloadData={() => {
        //   clearAndRefresh();
        // }}
        context={equipmentCode}
      /> */}
      <AccordionEquipmentGrid
        // actionButtons={RightComponents()}
        maxHeight="40px"
        description={equipmentDescription}
        toggleButton={openGrid}
        setToggleButton={setOpenGrid}
      >
        <TableTree
          ref={tableRef}
          rootCode={equipmentCode}
          hasMore={queryEquipmentsGrid.hasNextPage}
          data={tableData}
          columns={columns}
          // isLoading={isLoading}
          isRowLoading={isRowLoading}
          extraRowInfo={extraRowInfo}
          isRowSelected={isRowSelected}
          handleLoadChild={handleLoadChild}
          handleLoadMore={() => queryEquipmentsGrid?.fetchNextPage()}
          NoDataComponent={NoDataComponent()}
          LoadingDataComponent={LoadingDataComponent()}
        />
      </AccordionEquipmentGrid>
    </>
  );
};

export default GridTreeOthers;
